export default "__VITE_ASSET__95cc073c__"